<div class="my-3 my-md-5">
    <div class="container-fluid">
        <h1 class="page-title">OPD List</h1>
    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi *ngIf="myrole!='13'">
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                    <div class="row mb-2 mt-2">
                        <div class="col-sm-2 mt-2"><input class="form-control" [(ngModel)]="search" type="text" placeholder="Search" /></div>
                        <div class="col-sm-2 mt-2" *ngIf="myrole=='1' || myrole=='3'  || myrole=='4' || myrole=='9' || myrole=='10' || myrole=='15' || myrole=='18'">
                            <mat-select  placeholder="Bds"  [(ngModel)]="bd" (click)="setSearchValue('lead_owner')" multiple>
                                <input class="mySearchInput"
                                #ownerSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'lead_owner')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="ownerSearch">
                                <!-- <mat-option >All</mat-option> -->
                                <mat-option value="{{bd.id}}" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Circle" [(ngModel)]="circle" multiple>
                                <!-- <mat-option >All</mat-option> -->
                                <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2" *ngIf="doctorFilter">
                            <mat-select  placeholder="Doctor"  [(ngModel)]="doctor" (click)="setSearchValue('doctor')" multiple>
                                <input class="mySearchInput"
                                #doctorSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'doctor')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="doctorSearch">
                                <!-- <mat-option >All</mat-option> -->
                                <mat-option [value]="odoctor.id" *ngFor="let odoctor of doctors">{{odoctor.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2" *ngIf="hospitalFilter">
                            <mat-select  placeholder="Hospital" [(ngModel)]="hospital" (click)="setSearchValue('hospital')" multiple>
                                <input class="mySearchInput"
                                #hospitalSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'hospital')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="hospitalSearch">
                                <!-- <mat-option >All</mat-option> -->
                                <mat-option [value]="ohospital.id" *ngFor="let ohospital of hospitals">{{ohospital.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Treatment" [(ngModel)]="treatment" (click)="setSearchValue('treatment')" multiple>
                                <input class="mySearchInput"
                                #treatmentSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'treatment')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="treatmentSearch">
                                <!-- <mat-option >All</mat-option> -->
                                <mat-option value="{{ltreatment.id}}" *ngFor="let ltreatment of treatments">{{ltreatment.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Status"  [(ngModel)]="status" multiple>
                                <!-- <mat-option >All</mat-option> -->
                                <mat-option value="0">Active</mat-option>
                                <mat-option value="1">Completed</mat-option>
                                <mat-option value="3">Cancelled</mat-option>
                                <mat-option value="2" *ngIf="myrole=='1'">Deleted</mat-option>

                            </mat-select>
                        </div>

                        <div class="col-sm-2 mt-2" *ngIf="myrole!='2'">
                            <mat-select  placeholder="Lead Source"  [(ngModel)]="lead_source" multiple>
                                <mat-option value="{{lsources.id}}" *ngFor="let lsources of lead_sources">{{lsources.source_name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Payment Mode" [(ngModel)]="payment_mode" multiple>
                                <mat-option value="Cash">Cash</mat-option>
                                <mat-option value="Cashless">Cashless</mat-option>
                                <mat-option value="Reimbursement">Reimbursement</mat-option>
                                <mat-option value="EMI">EMI</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Surgery Suggested"  [(ngModel)]="surgery_suggested" multiple>
                                <!-- <mat-option >All</mat-option> -->
                                <mat-option value="0">Pending</mat-option>
                                <mat-option value="1">Yes</mat-option>
                                <mat-option value="2">No</mat-option>


                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Feedback Status"  [(ngModel)]="feedbackStatus" multiple>
                                <!-- <mat-option>All</mat-option> -->
                                <mat-option value="null">Pending</mat-option>
                                <mat-option value="1">Active</mat-option>
                                <mat-option value="2">Follow-Up 1</mat-option>
                                <mat-option value="3">Follow-Up 2</mat-option>
                                <mat-option value="4">Not Received</mat-option>
                                <mat-option value="5">Completed</mat-option>
                                <mat-option value="6">OPD not Done</mat-option>
                                <mat-option value="7">Closed</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Lead Catergory" [(ngModel)]="lead_category_filter" multiple>
                                <mat-option value="{{catergory.id}}" *ngFor="let catergory of treatCategory">{{catergory.name}}</mat-option>
                            </mat-select>
                          </div>
                        <div class="col-sm-3 mt-2">
                            <mat-form-field appearance="fill">
                                <mat-label>Enter a date range</mat-label>
                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate #dateRangeStart placeholder="Start date">
                                    <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="clearDate()">clear</mat-icon>
                        </div>

                        <div class="col-sm-3 mt-2" *ngIf="myrole=='1' || myrole=='4' ">
                            <mat-form-field appearance="fill">
                                <mat-label>Feedback Follow up date range</mat-label>
                                <mat-date-range-input [rangePicker]="picker1">
                                    <input matStartDate #followupDateRangeStart placeholder="Start date">
                                    <input matEndDate #followupDateRangeEnd placeholder="End date" (dateChange)="followupDateRangeChange(followupDateRangeStart, followupDateRangeEnd)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker1></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="clearFollowupDate()">clear</mat-icon>
                        </div>

                        <div class="float-right mt-6">
                            <label class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input"  [(ngModel)]="showPendingPrescription">
                                <span class="custom-control-label">Show Pending Prescriptions Opd</span>
                              </label>
                        </div>

                        <div class="col-sm-2 mt-5" *ngIf="myrole=='1' || myrole=='4' ">
                                <mat-select  placeholder="Prescription Auditing" [(ngModel)]="prescriptionAuditing">
                                <mat-option value="1">Yes</mat-option>
                                <mat-option value="2">No</mat-option>
                                </mat-select>
                        </div>

                        <div class="col-sm-2 mt-5" *ngIf="myrole=='1' || myrole=='4' ">
                            <mat-select  placeholder="Approval Action" [(ngModel)]="selectAction">
                                <mat-option value="1">Yes</mat-option>
                                <mat-option value="2">No</mat-option>
                            </mat-select>
                        </div>

                        <div class="col-sm-2 mt-5" *ngIf="myrole=='1' || myrole=='4' ">
                            <mat-select  placeholder="Uploaded Prescriptions" [(ngModel)]="prescriptionFilter">
                            <mat-option value="1">Yes</mat-option>
                            <mat-option value="2">No</mat-option>
                            </mat-select>
                        </div>

                        <div class="col-sm-3 mt-5">
                            <button type="button" class="btn btn-primary ml-2 mb-4" (click)="loadOpds(0,perpage)"> <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                            <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i class="fa fa-sync"></i> Reset Filters</button>
                          </div>
                    </div>
                </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3">
                    <button type="button" class="btn btn-success" [disabled]="loading" (click)="loadOpds(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button>

                    <button type="button" *ngIf="myrole=='1' || myrole=='15'" class="btn btn-success ml-2" [disabled]="loading" (click)="exportOpdList()"><i class="fa fa-file-excel"></i> Export List</button>

                    <!-- <span *ngIf="myrole=='1'"><a class="float-right btn btn-success text-white" (click)="showModalGlamyoShares()"><i class="fa fa-file-excel"></i> Import Opd Shares</a><br>
                        <a class="float-right" href="{{sc3Url}}crm/shares/opd_shares.csv" target="_blank">Sample CSV</a></span>  -->

                </div>
                <div class="col-sm-6"><mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator></div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Surgery Suggested</th>
                        <th>Status</th>
                        <th>Medical Officer Action Status</th>
                        <th>Feedback Status</th>
                        <th *ngIf="myrole!='2'">Lead Source</th>
                        <th>Appointment Id</th>
                        <th>Glamyo Patient Id</th>
                        <th>Glamyo Appointment Id</th>
                        <th class="tablefixcoloumn">Patient Name</th>
                        <!-- <th *ngIf="userId!='16' && myrole!='6' && myrole!='10' && myrole!='18'">Patient Mobile</th> -->
                        <th>Patient Mobile</th> 
                        <th *ngIf="myrole=='1' || myrole=='4'">Kaleyra C2C</th>
                        <th *ngIf="myrole=='1' || myrole=='4'">Call Details</th>
                        <th>OPD Circle</th>
                        <th>Lead Circle</th>
                        <th>Created Date</th>
                        <th>Lead Owner</th>
                        <th>Employee Id</th>
                        <th>Treatment</th>
                        <th>Treatment Catergory</th>
                        <th>Payment Mode</th>
                        <th>Consultation Fee</th>
                        <th>Consultation Type</th>
                        <th>Doctor</th>
                        <th>Hospital</th>
                        <th>Appointment Time</th>
                        <th *ngIf="myrole!='13'">Prescription</th>
                        <th *ngIf="myrole!='13' && myrole!='16'">Case Papers</th>
                        <th>Feedback Person</th>
                        <th>Approved Person</th>
                        <th>Campaign Name</th>
                        <th>Keywords</th>
                        <th>AD Group Id</th>
                        <th>Match Type</th>
                        <th>Form Lead Source</th>
                        <th *ngIf="myrole=='1' || myrole=='4' ">Feedback Follow Up Date</th>
                        <th *ngIf="myrole=='1' || (myrole=='4' && isCMAccess=='1')">Assigned To</th>
                        <th *ngIf="myrole=='1' || (myrole=='4' && isCMAccess=='1')">Assign To</th>
                        <th *ngIf="myrole!='6' && myrole!='13' && myrole!='10' && myrole!='16' && myrole!='7'">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let opd of opds;let index = index;">
                        <td >{{(pageIndex*perpage)+index+1}}</td>
                        <td>
                            <span class='badge' [ngClass]="{'badge-info':opd.surgery_suggested==0}" *ngIf="opd.surgery_suggested==0">Pending</span>
                            <span class='badge' [ngClass]="{'badge-success':opd.surgery_suggested==1}" *ngIf="opd.surgery_suggested==1">Yes</span>
                            <span class='badge' [ngClass]="{'badge-danger':opd.surgery_suggested==2}" *ngIf="opd.surgery_suggested==2">No</span>
                        </td>
                        <td>
                            <span class='p-2 badge' [ngClass]="{'badge-info':opd.status==0}" *ngIf="opd.status==0"><i class="fa fa-dot-circle"></i> Active</span>
                            <span class='p-2 badge' [ngClass]="{'badge-success':opd.status==1}" *ngIf="opd.status==1"><i class="fa fa-check"></i> Completed</span>
                            <span class='p-2 badge' [ngClass]="{'badge-danger':opd.status==3}" *ngIf="opd.status==3"><i class="fa fa-times"></i> Cancelled</span>
                        </td>
                        <td>
                          <span class='p-2 badge' [ngClass]="{'badge-success':opd.approved_status==1}" *ngIf="opd.approved_status==1"><i class="fa fa-check"></i> Approved</span>
                          <span class='p-2 badge' [ngClass]="{'badge-danger':opd.approved_status==2}" *ngIf="opd.approved_status==2"><i class="fa fa-dot-circle"></i> Rejected</span>
                          <span class='p-2 badge' [ngClass]="{'badge-info':opd.approved_status==3}" *ngIf="opd.approved_status==3"><i class="fa fa-times"></i> Approved with High Risk</span>
                        </td>
                        <td>
                            <span class='p-2 badge btn-primary' *ngIf="opd.feedbackStatus==1"><i class="fa fa-dot-circle"></i> Active</span>
                            <span class='p-2 badge btn-info' *ngIf="opd.feedbackStatus==2"><i class="fa fa-dot-circle"></i> Follow-Up 1</span>
                            <span class='p-2 badge btn-info' *ngIf="opd.feedbackStatus==3"><i class="fa fa-dot-circle"></i> Follow-Up 2</span>
                            <span class='p-2 badge btn-danger' *ngIf="opd.feedbackStatus==4"><i class="fa fa-times"> </i> Not Received</span>
                            <span class='p-2 badge btn-success' *ngIf="opd.feedbackStatus==5"><i class="fa fa-check"></i> Completed</span>
                            <span class='p-2 badge btn-warning' *ngIf="!opd.feedbackStatus"><i class="fa fa-times"> </i> Pending</span>
                            <span class='p-2 badge btn-danger' *ngIf="opd.feedbackStatus==6"><i class="fa fa-times"> </i> OPD not Done</span>
                            <span class='p-2 badge btn-dark' *ngIf="opd.feedbackStatus==7"><i class="fa fa-check"> </i> Closed</span>
                        </td>
                        <td *ngIf="myrole!='2'">
                            <!-- <span class='p-2 badge btn-primary'>{{sharedapi.getLeadSource(opd.lead_source)}}</span> -->
                            <span class='p-2 badge btn-primary'>{{opd.source_name}}</span>
                        </td>
                        <td class="tablefixcoloumn">{{opd.appointment_id}}</td>
                        <td class="tablefixcoloumn">{{opd.glamyo_patient_id}}</td>
                        <td class="tablefixcoloumn">GHOPD{{opd.id}}</td>
                        <td class="tablefixcoloumn">{{opd.patient}}</td>
                        <!-- <td  *ngIf="userId!='16' && myrole!='6' && myrole!='10' && myrole!='18'">{{opd.phone}}</td> -->
                        <td> {{ myrole=='1' || (myrole=='4' && is_doctor_access!='1') ? opd.phone : '**********' }} </td>
                        <td *ngIf="myrole=='1' || myrole=='4'"><span class='p-2 badge btn-success pointer-cur' (click)="click_to_call_function(opd.lead_id)">Click to Call</span></td>
                        <td *ngIf="myrole=='1' || myrole=='4'"><span class='p-2 badge btn-primary pointer-cur' (click)="call_details(opd.lead_id)">Call Details</span></td>
                        <td>{{opd.circle_name}}</td>
                        <td>{{opd.lead_circle_name}}</td>
                        <td>{{opd.created_at*1000|date:'d MMM, yyyy hh:mm aa'}}</td>
                        <td>{{opd.bd_name}}</td>
                        <td>{{opd.employee_id}}</td>
                        <td>{{opd.treatment_name}}</td>
                        <td>{{opd.treatment_categoriesName}}</td>
                        <td>{{opd.payment_mode}}</td>
                        <td>{{opd.billed_amt}}</td>
                        <td>
                            <span *ngIf="opd.consultation_type==1">Online Consultation</span>
                            <span *ngIf="opd.consultation_type==2">Offline Consultation</span>
                        </td>
                        <td>{{opd.doctor_name}}</td>
                        <td>{{opd.hospital_name}}</td>
                        <td>{{opd.appointment_time*1000|date:'d MMM, yyyy hh:mm aa'}}</td>
                        <td *ngIf="myrole!='13'">
                            <div *ngIf="opd.prescription_link.length > 0; else noPrescription">
                                <span *ngFor="let plink of opd.prescription_link"><a href="{{sc3Url+plink.links}}" target="_blank">View</a><br></span>
                            </div>
                            <ng-template #noPrescription>
                                Not uploaded
                            </ng-template>
                        </td>
                        <td *ngIf="myrole!='13' && myrole!='16'"><a href="javascript:void(0);" (click)="openOpdDialog(opd.lead_id)" >View Case Papers</a></td>
                        <td>
                            <span *ngIf="opd.feedbackUserName; else noFeedbackuser">{{opd.feedbackUserName}}</span>
                            <ng-template #noFeedbackuser>
                                -
                            </ng-template>

                        </td>
                        <td>
                            <span *ngIf="opd.approvedPersonName; else noApproveduser">{{opd.approvedPersonName}}</span>
                            <ng-template #noApproveduser>
                                -
                            </ng-template>

                        </td>
                        <td>{{opd.campaign_name}}</td>
                        <td>{{opd.keywords}}</td>
                        <td>{{opd.utm_agid}}</td>
                        <td>{{opd.matchtype}}</td>
                        <td>{{opd.zoho_lead_source}}</td>
                        <td *ngIf="myrole=='1' || myrole=='4' ">
                            <span *ngIf="opd.feedback_followupdate != null; else feedback_followupdate_elseBlock">
                                {{opd.feedback_followupdate*1000|date:'d MMM, yyyy'}}
                            </span>
                            <ng-template #feedback_followupdate_elseBlock></ng-template>
                        </td>
                        <td *ngIf="myrole=='1' || (myrole=='4' && isCMAccess=='1')">{{opd.assigned_to}}</td>
                        <td *ngIf="myrole=='1' || (myrole=='4' && isCMAccess=='1')">
                            <div class="dropdown">
                               <button class="btn btn-secondary dropdown-toggle" type="button" id="{{opd.id}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                   Assign To
                               </button>
                               <div class="dropdown-menu">
                                   <a class="dropdown-item" *ngFor="let feedback_user of feedBackUser;" (click)="updateAssignee(feedback_user.id, opd.id)"><i class="fa fa-user"></i> {{feedback_user.name}} </a>
                               </div>
                           </div>
                       </td>
                            <td *ngIf="myrole!='6' && myrole!='13' && myrole!='10' && myrole!='16' && myrole!='7'">
                             <div class="dropdown">
                                <button class="btn btn-secondary dropdown-toggle" type="button" id="{{opd.id}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Action
                                </button>
                                <div class="dropdown-menu" aria-labelledby="{{opd.id}}">
                                    <!-- <a class="dropdown-item" *ngIf="opd.status==1 && (myrole==1 || myrole==4)" (click)="sendOpdReviewLink(opd.id)"><i class="fa fa-comment"></i> Send review link</a> -->
                                    <a class="dropdown-item pointer-cur" *ngIf="opd.status==0 && (myrole==1 || myrole==4)" (click)="markStatus(opd.id,1)"><i class="fa fa-check"></i> Complete OPD</a>
                                    <a class="dropdown-item pointer-cur" *ngIf="opd.status==0 && myrole!=9 && myrole!=15" (click)="markStatus(opd.id,3)"><i class="fa fa-times"></i> Cancel OPD</a>
                                    <a class="dropdown-item pointer-cur" *ngIf="myrole!=9 && myrole!=14 && myrole!=15" (click)="openOpdDialog(opd.lead_id)"><i class="fa fa-pen"></i> Update OPD</a>
                                    <a class="dropdown-item pointer-cur" *ngIf="myrole!=15" (click)="viewOpd(opd.id)"><i class="fa fa-eye"></i> View OPD</a>
                                    <a *ngIf="myrole=='1' || myrole=='4'" class="dropdown-item" routerLink="/add-opd-feedback/{{opd.id}}"><i class="fa fa-pen"></i>
                                        <span >Add Feedback</span>
                                    </a>
                                    <a *ngIf="myrole=='1' || myrole=='4'" class="dropdown-item pointer-cur" (click)="openPrescriptionAuditingDialog(opd.lead_id)"><i class="fa fa-pen"></i> Prescription Auditing</a>
                                    <a *ngIf="myrole=='1' || userId=='313' || userId=='268'" class="dropdown-item pointer-cur" (click)="viewopdHistory(opd.id)"><i class="fa fa-eye"></i> View History</a>
                                </div>
                            </div>
                        </td>

                    </tr>
                    <tr *ngIf="loading">
                        <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                    </tr>
                    <tr *ngIf="loaded && !opds.length">
                        <td colspan="20" ><i class="far fa-frown"></i> Opds not found</td>
                    </tr>
                </tbody>
            </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>
    </div>
</div>

<!-- The Modal to view opd -->
<div class="modal fade" id="myModal">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">OPD Schedule </h4>
        <button type="button" class="close" (click)="hideModal()"></button>
      </div>

      <!-- Modal body -->
        <div class="modal-body"id="pdfTable" #pdfTable>
           <div><h3><span style="color:#0f74b2">Glamyo</span>&nbsp;<span style="color:#69bb45">Health</span></h3></div>
           <table>
                <tr>
                  <th colspan="2">OPD Details</th>

                </tr>
                <tr>
                  <td><strong>Opd Id -</strong></td>
                  <td> GHOPD{{opdDetail.id}}</td>
                </tr>
                <tr>
                    <td><strong>Patient Name -</strong></td>
                    <td> {{opdDetail.patient}}</td>
                </tr>
                <tr>
                    <td><strong>Medical Coordinator -</strong></td>
                    <td> {{opdDetail.bd_name}}</td>
                </tr>
                <tr>
                    <td><strong>Doctor Name -</strong></td>
                    <td> {{opdDetail.doctor_name}}</td>
                </tr>
                <tr>
                    <td><strong>Treatment -</strong></td>
                    <td>{{opdDetail.treatment_name}}</td>
                </tr>
                <tr>
                    <td><strong>Hospital Name -</strong></td>
                    <td>{{opdDetail.hospital_name}}</td>
                </tr>
                <tr>
                    <td><strong>Address -</strong></td>
                    <td>{{opdDetail.address}}</td>
                </tr>
                <tr>
                    <td><strong>Location -</strong></td>
                    <td><span style="color: blue; text-decoration: underline;">{{opdDetail.location}}</span></td>
                </tr>
                <tr>
                    <td><strong>Appointment Date -</strong></td>
                    <td> {{opdDetail.appointment_time*1000 | date:'dd MMM, yyyy'}}</td>
                </tr>
                <tr>
                    <td><strong>Appointment Time at the center -</strong></td>
                    <td>{{opdDetail.appointment_time*1000|date:'hh:mm aa'}}</td>
                </tr>
                <tr>
                    <td><strong>Fee -</strong></td>
                    <td>{{opdDetail.billed_amt}}</td>
                </tr>
            </table>
        </div>

      <!-- Modal footer -->
      <div class="modal-footer">
        <button class="btn btn-primary" (click)="downloadAsPDF()">Share</button>
        <button type="button" class="btn" (click)="hideModal()">Close</button>
      </div>
    </div>
  </div>
</div>


 <!-- The Modal to view Billed Amount History -->
<div class="modal fade" id="BilledModal">
<div class="modal-dialog modal-lg">
    <div class="modal-content">

    <!-- Modal Header -->
    <div class="modal-header">
        <h5 class="modal-title billedTitle">History</h5>
        <button type="button" class="close" (click)="hideHistroyModal()"></button>
    </div>

    <!-- Modal body -->
    <div class="col-sm-12">
        <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
            <tbody>
                <tr *ngFor="let opdbilled of opdHistoryDetail">
                    <td>
                        <div  class="small_text" [innerHTML]="opdbilled.message | safe:'html'"></div>
                        <div class="small text-muted small_text_creation">
                            <i class="fas fa-clock"></i> {{opdbilled.created_at*1000|date:'d MMM, yyyy H:mm aa'}}
                        </div>
                    </td>
                </tr>
                <tr *ngIf="!opdHistoryDetail.length && billedloaded">
                    <td>No history found</td>
                </tr>
                <tr *ngIf="billedloading">
                    <td><i class="fa fa-spin fa-spinner"></i></td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Modal footer -->
    <div class="modal-footer">
        <button type="button" class="btn" (click)="hideHistroyModal()">Close</button>
    </div>
    </div>
</div>
</div>

<!-----------------For Click to Call-------------------------->
<div class="modal fade" id="click_to_call_progress" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title" style="font-weight: bold;">Call Progression</h4>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
                <div class="alert alert-danger" *ngIf="progression_msg">
                  <strong>Warning!</strong> {{progression_msg}}
                </div>
                <div class="form-group">
                  <div class="row">
                    <div style="font-size: 18px;" class="col-sm-12 modal-title text-center" id="click_to_call_progress_html">
                      <i class="fa fa-cog fa-spin"></i><br />
                      <h2>Call is under progress.</h2>
                    
                    </div>
                  </div>
                </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" [disabled]="end_to_call_btn_disable" class="btn btn-success" (click)="endClicktoCall()">Close</button>
        </div>
      </div>
    </div>
</div>
<!-----------------opd call Details-------------------------->
<div class="modal fade" id="opd_call_details" data-keyboard="false" data-backdrop="static" style="margin-top:80px ;">
    <div class="modal-dialog modal-lg modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title" style="font-weight: bold;">Call Details</h4>
        </div> 
        <!-- Modal body -->
          <div class="modal-body">
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-12 modal-title text-center">
                        <div style="overflow-x:auto;">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">Name</th>
                            <th scope="col">Duration <small>(In Minutes)</small></th>
                            <th scope="col">Time</th>
                            <th colspan="2">Call Recording Link</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let callData of callDeatils;let index = index;">
                            <th scope="row">{{index+1}}</th>
                            <td>{{callData.call_by_name}}</td>
                            <td>{{(callData.call_duration/60)|number : '.2-2'}}</td>
                            <td> {{callData.created_at*1000|date:'d MMM, yyyy H:mm aa'}}</td>
                            <td [innerHTML]="callData.click_to_call_recording_links"></td>
                            <td>
                            <button  class="pointer-cur" (click)="copyMessage('http://'+callData.click_to_call_link_only)"><i class="fa fa-copy"></i></button>
                            </td>
                          </tr>
                          <tr *ngIf="loaded && !callDeatils.length">
                            <td colspan="5"><i class="far fa-frown"></i> Data not found</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
          </div>
  </div>
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button"  class="btn btn-success" id="opd_call_details" (click)="closeCallDetailsModal()">Close</button>
        </div>
      </div>
    </div>
</div>

<!-- Glamyo Shares Modal -->
<div class="modal fade" id="myModalGlamyoShares">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Import Shares </h4>
          <button type="button" class="close" (click)="hideModalGlamyoShares()"></button>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                      <label class="col-sm-12">Upload CSV</label>
                      <input [disabled]="submitted" type="file" #csvUploadShares (change)="selectFileOpdShare($event)" class="form-control" />
                  </div>
                  <span *ngIf="submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
              </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideModalGlamyoShares()">Close</button>
        </div>
      </div>
    </div>
</div>
